(function() {
    const node = document.getElementById('friday-swiper');
    const prev = document.getElementById('friday-swiper-prev');
    const next = document.getElementById('friday-swiper-next');

    if (!node) {
        return false;
    }

    const size = Number(node.dataset.size);
    // 初始化swiper
    const swiper = new window.Swiper(node, {
        autoplay: {
            delay: 5000//5秒切换一次
        },
        on: {
            slideChangeTransitionEnd: function() {
                const activeIndex = this.realIndex;
                if (activeIndex === 0) {
                    prev.classList.add('gray');
                } else {
                    prev.classList.remove('gray');
                }

                if (activeIndex === size - 1) {
                    next.classList.add('gray');
                } else {
                    next.classList.remove('gray');
                }
            }
        }
    });

    Array.prototype.slice.call(node.querySelectorAll('.friday-content'), 0).forEach(item => {
        item.style.paddingLeft = item.dataset.left / 1920 * 100 + 'vw';
    });

    prev && prev.addEventListener('click', function() {
        if (prev.classList.contains('gray')) {
            return false;
        }

        swiper.slidePrev();
    });

    next && next.addEventListener('click', function() {
        if (next.classList.contains('gray')) {
            return false;
        }
        swiper.slideNext();
    });

    let _timer = null;
    window.addEventListener('resize', function() {
        clearTimeout(_timer);
        _timer = setTimeout(() => {
            swiper.updateSize();
        }, 100);
    });
})();